import React, { useState } from 'react'
import { finalizeRound } from 'components/flags/api'
import PackageModal from 'components/packages/modals/PackageModal'
import { closePackageModal, openPackageModal } from 'lib/openPackageModal'

export default function SummaryReadyModal({ packageHashedId, incomplete = 0, complete = 0 }) {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleIssueResponse = async () => {
    if (submitting) return
    setError(null)
    setSubmitting(true)
    try {
      await finalizeRound(packageHashedId)
      await openPackageModal(packageHashedId, 'summary_sent')
    } catch (err) {
      console.error('[SummaryReadyModal] finalizeRound error', err)
      setError('Something went wrong issuing this response. Please try again.')
      setSubmitting(false)
    }
  }

  return (
    <PackageModal isOpen onClose={closePackageModal}>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <span className="dome-h2 dome-color-dark-green">summary ready to send</span>
        <span className="dome-p1 dome-color-dark-grey">
          application status:{' '}
          <span className="dome-h5 dome-color-red-alert dome-text-w500">
            {incomplete > 0 ? 'incomplete' : 'complete'}
          </span>
        </span>
        <div className="dome-d-flex dome-gap24">
          <div style={{ width: 87 }} className="dome-d-flex dome-flex-column dome-justify-start">
            <span className="dome-p3 dome-color-med-grey">incomplete</span>
            <span className="dome-h2 dome-color-dark-grey">{incomplete}</span>
          </div>
          <div style={{ width: 87 }} className="dome-d-flex dome-flex-column dome-justify-start">
            <span className="dome-p3 dome-color-med-grey">complete</span>
            <span className="dome-h2 dome-color-dark-grey">{complete}</span>
          </div>
        </div>
        {error && <span className="dome-p2 dome-color-red">{error}</span>}
        <div className="dome-d-flex dome-justify-between">
          <button
            type="button"
            onClick={closePackageModal}
            className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
          >
            still reviewing
          </button>
          <button
            type="button"
            onClick={handleIssueResponse}
            disabled={submitting}
            className="dome-btn dome-btn-base dome-btn-dark-green"
          >
            {submitting ? 'issuing...' : 'issue response'}
          </button>
        </div>
      </div>
    </PackageModal>
  )
}
